import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vehicleSelectWrapperComponent mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-danger"
}
const _hoisted_3 = {
  key: 1,
  class: "container-vehicles__wrapper"
}
const _hoisted_4 = { class: "vehicle-card__header__data font-medium" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fw-600 margin-bottom-0 align-self-start" }
const _hoisted_7 = { class: "font-big font-color align-self-start pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VehicleCardComponent = _resolveComponent("VehicleCardComponent")!
  const _component_VehicleInfoWrapperComponent = _resolveComponent("VehicleInfoWrapperComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (! _ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (! _ctx.vehiclesData.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('key_no_vehicles_that_matches_your_criteria')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehiclesData, (vehicle) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: vehicle.id
                  }, [
                    _createVNode(_component_VehicleCardComponent, {
                      onClick: ($event: any) => (_ctx.$helpers.openModal($event, {id: 'selected-vehicle-' + vehicle.id}, 'custom-modal-backdrop-0')),
                      class: _normalizeClass([vehicle.id === _ctx.store.state.vehicle.selectedId ? _ctx.isActive : null])
                    }, {
                      seats: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(vehicle.seats) + " " + _toDisplayString(_ctx.$t(_ctx.$helpers.wordEnding(vehicle.seats))), 1)
                      ]),
                      image: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "vehicle-card__body__car-image",
                          src: vehicle.vehicle_main_image ? vehicle.vehicle_main_image.path : '',
                          alt: "car-image"
                        }, null, 8, _hoisted_5)
                      ]),
                      maker_model: _withCtx(() => [
                        _createElementVNode("h5", _hoisted_6, _toDisplayString(vehicle.make) + " " + _toDisplayString(vehicle.model), 1)
                      ]),
                      price: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(vehicle.price) + " " + _toDisplayString(_ctx.$t('eur_h')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"]),
                    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                      _createVNode(_component_ModalComponent, {
                        "is-main-modal": false,
                        "show-link": true,
                        id: 'selected-vehicle-' + vehicle.id,
                        "z-index-custom": 'z-index-custom-0',
                        backdrop: 'custom-modal-backdrop-0',
                        "body-overflow": 'body-overflow'
                      }, {
                        "body-content": _withCtx(() => [
                          _createVNode(_component_VehicleInfoWrapperComponent, {
                            vehicle: vehicle,
                            "is-driver": _ctx.store.state.order.withDriver
                          }, null, 8, ["vehicle", "is-driver"])
                        ]),
                        _: 2
                      }, 1032, ["id"])
                    ]))
                  ], 64))
                }), 128))
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}